import React, { useRef } from "react";
import ServiceCard from "./ServiceCard";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectFade, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";

const Services = ({ desc, servicesData }) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  return (
    <div className="w-full flex flex-col lg:flex-row items-center gap-4 lg:gap-16 
    ">
      <div className="w-full lg:w-3/5">
        <div className="flex justify-center items-center mb-2">
          <h3 className="flex items-center gap-2 w-full font-semibold text-[#383838]">
            <span className="flex items-center whitespace-nowrap text-[17px] md:text-[22px]">
              <span className="text-[#383838]">چه </span>
              <span className="text-purple mx-1.5">خدماتی</span>
              <span className="text-[#383838] ml-1.5">ارائه می‌دهیم؟</span>
            </span>
            <span className="flex-1 h-[2px] rounded-full bg-gradient-to-l from-purple/10 to-transparent" />
          </h3>
        </div>

        <p className="text-gray-600 leading-6 md:leading-6.5 lg:leading-7 
        text-[13px] md:text-[14px] text-justify space-y-[2px]">
          {desc}
        </p>

        <div className="hidden lg:flex items-center justify-end lg:justify-start gap-1 mt-3">
          <button
            ref={prevRef}
            className="w-9 h-9 rounded-2xl border-2 border-gray-300/70 text-gray-500/70 flex items-center justify-center hover:bg-gray-100 hover:text-gray-600 hover:border-gray-200 transition-all duration-300 disabled:opacity-30"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>

          <button
            ref={nextRef}
            className="w-9 h-9 rounded-2xl border-2 border-gray-300/70 text-gray-500/70 flex items-center justify-center hover:bg-gray-100 hover:text-gray-600 hover:border-gray-200 transition-all duration-300 disabled:opacity-30"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2.5}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
        </div>
      </div>

      <div className="w-full lg:w-2/5 -mt-3 lg:mt-0">
        <Swiper
          modules={[Navigation, EffectFade, Autoplay]}
          effect="fade"
          fadeEffect={{ crossFade: false }}
          speed={1500}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          onBeforeInit={(swiper) => {
            swiper.params.navigation.prevEl = prevRef.current;
            swiper.params.navigation.nextEl = nextRef.current;
          }}
        >
          {servicesData?.map((card) => (
            <SwiperSlide key={card.id}>
              <ServiceCard
                title={card.title}
                text={card.description}
                img={card.image}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Services;
